import router from './router'
import accidentMessages from './localization'

export default {
  router,
  localization: accidentMessages,
}
